import { QRCodeCanvas } from "qrcode.react";
import { useState, useEffect } from "react";

export default function QRLanding({ user, scanning, setScanning, themeColor }) {

    const [showQr, setShowQr] = useState(false);
    useEffect(() => {
        let wakeLock;

        const requestWakeLock = async () => {
            try {
                wakeLock = await navigator.wakeLock?.request("screen");
            } catch { }
        };

        if (showQr) {
            requestWakeLock();
        }

        return () => {
            wakeLock?.release();
        };
    }, [showQr]);

    return (
        <div className="container mt-5">
            <div
                className="mx-auto p-4 p-md-5 text-center shadow-sm"
                style={{
                    maxWidth: "500px",
                    borderRadius: "30px",
                    backgroundColor: "var(--card-bg)",
                    border: "1px solid var(--border-color)"
                }}
            >
                {/* Animated Icon Header */}
                <div className="mb-4 position-relative d-inline-block">
                    <div
                        className="position-absolute top-50 start-50 translate-middle w-100 h-100 rounded-circle"
                        style={{
                            backgroundColor: themeColor,
                            opacity: 0.1,
                            transform: "scale(1.5)",
                            filter: "blur(20px)"
                        }}
                    ></div>
                    <i className={`bi bi-phone-vibrate display-4 position-relative`} style={{ color: themeColor }}></i>
                </div>

                <h2 className="fw-bold mb-2" style={{ color: "var(--text-color)" }}>Ready to Play?</h2>
                <p style={{ color: "var(--bs-secondary-color)" }}>
                    Check-in at the venue to secure your spot. Scan the club's QR code or show your own to the queue manager.
                </p>

                {/* Action Button */}
                {!scanning ? (
                    <>
                        <button
                            className="btn btn-lg w-100 rounded-pill mt-3 d-flex align-items-center justify-content-center gap-3"
                            onClick={() => setScanning(true)}
                            style={{
                                backgroundColor: themeColor,
                                color: "white",
                                padding: "15px 30px",
                                fontWeight: "600",
                                border: "none",
                                boxShadow: `0 8px 20px ${themeColor}30`,
                                transition: "transform 0.2s ease"
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-3px)"}
                            onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                        >
                            <i className="bi bi-qr-code-scan fs-4"></i>
                            Scan QR Code
                        </button>
                        <button
                            className="btn btn-lg w-100 rounded-pill mt-3 d-flex align-items-center justify-content-center gap-3"
                            onClick={() => setShowQr(true)}
                            style={{
                                backgroundColor: themeColor,
                                color: "white",
                                padding: "15px 30px",
                                fontWeight: "600",
                                border: "none",
                                boxShadow: `0 8px 20px ${themeColor}30`,
                                transition: "transform 0.2s ease"
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-3px)"}
                            onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                        >
                            <i className="bi bi-qr-code"></i>
                            Show My QR Code
                        </button>
                    </>
                ) : (
                    /* Scanner Container */
                    <div className="mt-4 overflow-hidden shadow-inner"
                        style={{
                            borderRadius: "20px",
                            background: "var(--surface-bg)",
                            border: `3px solid ${themeColor}40`
                        }}>
                        <div id="qr-reader" style={{ width: "100%" }} />
                        <button
                            className="btn btn-sm opacity-75"
                            style={{ color: "var(--text-color)" }}
                            onClick={() => setScanning(false)}
                        >
                            Cancel Scan
                        </button>
                    </div>
                )}

                <div className="mt-4 pt-3 border-top">
                    <span
                        className="badge rounded-pill fw-normal px-3 py-2"
                        style={{
                            backgroundColor: "var(--surface-bg)",
                            color: "var(--text-color)",
                            border: "1px solid var(--border-color)"
                        }}
                    >
                        <i className="bi bi-geo-alt-fill me-1 text-danger"></i>
                        Check-in required at venue
                    </span>
                </div>
                {/* <button
                    className="btn btn-lg w-100 rounded-pill mt-3 d-flex align-items-center justify-content-center gap-3 transition-all"
                    style={{
                        backgroundColor: themeColor,
                        color: "white",
                        padding: "15px 30px",
                        fontWeight: "600",
                        border: "none",
                        boxShadow: `0 8px 20px ${themeColor}30`,
                        transition: "transform 0.2s ease"
                    }}
                    onClick={() => handleLogout()}
                >
                    Logout
                </button> */}
                {showQr && (
                    <>
                        {/* Clean Backdrop: Styled to be slightly frosted/white instead of dark */}
                        <div
                            className="modal-backdrop fade show"
                            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", backdropFilter: "blur(4px)" }}
                            onClick={() => setShowQr(false)}
                        />

                        <div
                            className="modal fade show d-block"
                            tabIndex="-1"
                            role="dialog"
                            aria-modal="true"
                            style={{ zIndex: 1055 }}
                        >
                            <div className="modal-dialog modal-dialog-centered px-3" style={{ maxWidth: '400px' }}>
                                <div className="modal-content border-0 shadow-lg rounded-5 overflow-hidden">

                                    {/* Header with a Violet tint */}
                                    <div className="modal-header border-0 pb-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                                        <h5 className="fw-bold mb-0" >My QR</h5>
                                        <button
                                            type="button"
                                            className="btn-close shadow-none"
                                            onClick={() => setShowQr(false)}
                                        />
                                    </div>

                                    <div className="modal-body text-center p-4">
                                        <div className="d-flex justify-content-center align-items-center">
                                            <div
                                                className="p-3 rounded-4"
                                                style={{ backgroundColor: "#fff" }}
                                            >
                                                <QRCodeCanvas
                                                    size={280} // Reduced size slightly for better mobile fit
                                                    value={JSON.stringify({
                                                        uid: user.uid,
                                                        name: user.displayName,
                                                        username: user.username || null,
                                                        photoURL: user.photoURL || null,
                                                        level: user.level || 1,
                                                    })}
                                                    bgColor={"#ffffff"}
                                                    fgColor={themeColor}
                                                    level={"H"}
                                                    imageSettings={{
                                                        src: "/img/rrc2.png",
                                                        height: 45,
                                                        width: 45,
                                                        excavate: true,
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-4">
                                            <p className="text-muted small px-3">
                                                Show this QR to the queue admin
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}